<agpr-dialog-container
    [id]="id"
    class="agpr-precisionLoading"
    heading="Monitor.precisionClip.loading.inProgress"
    headingIcon="fa-kit-duotone fa-agpr-ai-generic"
    [closeOnClickOutside]="true"
    [showClose]="false"
    [modal]="true"
    (close)="dismiss()"
>
    <div class="agpr-precisionLoading-content">
        <span> {{ 'Monitor.precisionClip.loading.message' | localize }} </span>
        @if (precisionClipProcess) {
            @let currentCount = precisionClipProcess.clipsCompleted + precisionClipProcess.clipsFailed;
            <div class="agpr-precisionLoading-group">
                <p-progressBar
                    class="agpr-precisionLoading-progressBar"
                    [value]="currentCount / precisionClipProcess.totalClipsToComplete * 100"
                    [showValue]="false"
                ></p-progressBar>
                <span> {{ 'Monitor.precisionClip.loading.precisionClipped' | localize: { 'num': currentCount, 'dem': precisionClipProcess.totalClipsToComplete} }} </span>
            </div>
        }

        <agpr-message
            [severity]="messageSeverityEnum.info"
            [bottomMargin]="false"
        >
            {{ 'Monitor.precisionClip.loading.infoBanner' | localize }}
        </agpr-message>
    </div>


    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_dismissButton'"
            label="Monitor.precisionClip.loading.dismiss"
            [style]="buttonType.primary"
            (click)="dismiss()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
